export default class Mask {
    constructor() {
        this.decimalSeparator = '.';
    }

    zipcode(value) {
        if (value.match(/^[0-9]/)) {
            return '9999';
        }
        else {
            //With '*' instead of 'a' else is always applied.
            return '*a 9999';
        }
    }

    birthdate() {
        return '39-19-2999';
    }
}
